/**
 * Detects whether the CSV text uses ',', ';', '\t', or '|' as the column delimiter
 */
export function detectDelimiter(text) {
  let inQuotes = false;
  const counts = { ',': 0, ';': 0, '\t': 0, '|': 0 };
  const sample = text.slice(0, 4096);
  for (let i = 0; i < sample.length; i++) {
    const c = sample[i];
    if (c === '"') {
      inQuotes = !inQuotes;
    } else if (!inQuotes && counts[c] !== undefined) {
      counts[c]++;
    } else if (!inQuotes && (c === '\n' || c === '\r')) {
      if (counts[','] > 0 || counts[';'] > 0 || counts['\t'] > 0 || counts['|'] > 0) {
        break;
      }
    }
  }
  let best = ',';
  let max = 0;
  for (const [delim, count] of Object.entries(counts)) {
    if (count > max) {
      max = count;
      best = delim;
    }
  }
  return best;
}

/**
 * Parses CSV text into a 2D array of rows/columns
 */
export function parseCSV(text) {
  if (!text) return [];
  // Strip UTF-8 BOM if present
  if (text.charCodeAt(0) === 0xFEFF) {
    text = text.slice(1);
  }

  const delimiter = detectDelimiter(text);
  const rows = [];
  let currentRow = [];
  let currentValue = '';
  let inQuotes = false;
  const len = text.length;

  for (let i = 0; i < len; i++) {
    const char = text[i];
    const nextChar = text[i + 1];
    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        currentValue += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === delimiter && !inQuotes) {
      currentRow.push(currentValue.trim());
      currentValue = '';
    } else if ((char === '\n' || char === '\r') && !inQuotes) {
      currentRow.push(currentValue.trim());
      if (currentRow.length > 0 && currentRow.some(c => c.length > 0)) {
        rows.push(currentRow);
      }
      currentRow = [];
      currentValue = '';
      if (char === '\r' && nextChar === '\n') i++;
    } else {
      currentValue += char;
    }
  }
  if (currentValue || currentRow.length > 0) {
    currentRow.push(currentValue.trim());
    if (currentRow.length > 0 && currentRow.some(c => c.length > 0)) {
      rows.push(currentRow);
    }
  }
  return rows;
}
